import styled from 'styled-components';
import TableComponent from '@/trio-ui/Table';
import { JobInfo } from '@/types/api/staffMember';

export const Table = styled(TableComponent<JobInfo>)`
  tbody {
    td {
      & > div {
        display: flex;
        align-items: center;

        & > span {
          display: block;
          flex-grow: 1;
        }
      }
    }

    td:first-child svg {
      height: 20px;
      width: 20px;
      margin-right: 10px;
      fill: ${({ theme }) => theme.colors['neutral-100']};
    }

    th:last-child,
    td:last-child {
      width: 52px;
    }

    td:last-child > div {
      display: flex;
      justify-content: space-between;
    }
  }
`;

export const TableContainer = styled.div`
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
`;
